import React from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { fontSizePieChart } from '../../../common/commonFun';

// Register Chart.js components and plugins
ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const CoPayPatientAgeChart = () => {
  const data = {
    labels: ['<30 years', '31-40 years', '41-50 years', '51+ years', 'Prefer not to say'],
    datasets: [
      {
        label: 'Patient Gender Distribution',
        data: [5, 10, 16, 61, 8],
        backgroundColor: ['rgba(46, 156, 158, 1)', 'rgba(87, 176, 178, 1)', 'rgba(130, 194, 196, 1)', 'rgba(150, 204, 207, 1)', 'rgba(191, 224, 227, 1)', ],
        borderWidth: 3,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 30,
        bottom: 20,
      },
    },
    plugins: {
      legend: {
        display: false, // Custom legend is implemented below
      },
      datalabels: {
        anchor: 'end',
        align: 'end',
        color: '#54667A',
        font: {
          family: 'Open Sans',
          size: fontSizePieChart(),
          weight: 600,
        },
        offset: 3,
        formatter: (value, context) => {
          const total = context.chart.data.datasets[0].data.reduce((acc, val) => acc + val, 0);
          const percentage = Math.round((value / total) * 100);
          return percentage + '%'; // Display percentage for each slice
        },
      },
    },
  };

  return (

    <div className="col-lg-6">
      <div className="card rounded-0 border-dark-700 h-100 d-flex justify-content-between py-4">
        <div className="card-header bg-transparent border-0">
          <h3 className="text-secondary fw-bold fs-30 text-center mt-1">Patient age</h3>
        </div>
        <div className="card-body">
          <div>
            <Pie data={data} options={options} id="copayPatientAge" className="pieChart" width="100%" />
          </div>
        </div>
        <div className="card-footer bg-transparent border-0">
          <div className="Legend d-flex justify-content-start px-2 flex-wrap">
            <div className="copay-chart color-1 fw-bold text-dark-gray fs-20 pe-2 pb-2"><span></span>&lt;30 Years</div>
            <div className="copay-chart color-2 fw-bold text-dark-gray fs-20 pe-2 pb-2"><span></span>31-40 Years</div>
            <div className="copay-chart color-4 fw-bold text-dark-gray fs-20 pe-2 pb-2"><span></span>41-50 Years</div>
            <div className="copay-chart color-5 fw-bold text-dark-gray fs-20 pe-2 pb-2"><span></span>51+ Years</div>
            <div className="copay-chart color-7 fw-bold text-dark-gray fs-20 pe-2"><span></span>Prefer not to say</div>
          </div>
        </div>
      </div>
    </div>

  );
};

export default CoPayPatientAgeChart;
